"use client";
import PropTypes from "prop-types";

import SaveTheSearchButton from "components/save-the-search-button";
import { numberFormatter } from "helpers/number-formatter";

import styles from "./styles.module.css";

const TopItemsWrapper = ({ name, urlPath, totalListingLength, listingName, seoTitle }) => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.titleContainer}>
        <div className={styles.mainTitle}>
          <h1 className={styles.title}>{seoTitle?.h1}</h1>
          {totalListingLength > 0 ? (
            <span className={styles.adsCount}>
              araması için <strong className={styles.strong}>{numberFormatter(totalListingLength)}</strong> ilan bulundu
            </span>
          ) : (
            <span className={styles.adsCount}>araması için uygun ilan bulunamadı</span>
          )}
        </div>
        <h2 className={styles.subTitle}>{seoTitle?.h2}</h2>
      </div>
      <SaveTheSearchButton name={name} urlPath={urlPath} />
    </div>
  );
};

TopItemsWrapper.propTypes = {
  name: PropTypes.string,
  urlPath: PropTypes.string,
  totalListingLength: PropTypes.number,
  listingName: PropTypes.string,
  seoTitle: PropTypes.object,
};

export default TopItemsWrapper;
